<template>
  <div class="image-item-wrapper">
    <div class="image-item">
      <!-- image el START -->
      <template v-if="source">
        <div
          :class="[
            'image-el-wrapper',
            imageLayout === 'square' ? 'image-el-wrapper--square': ''
          ]">
          <template v-if="lazy">
            <img
              :class="[
                'image-el',
                imageLayout === 'square' ? 'image-el--square': ''
              ]"
              :data-src="source"
              :alt="description"
              @click.prevent.stop="imageItemDidPress">
          </template>
          <template v-else>
            <img
              :class="[
                'image-el',
                imageLayout === 'square' ? 'image-el--square': ''
              ]"
              :src="source"
              :alt="description"
              @click.prevent.stop="imageItemDidPress">
          </template>
        </div>
      </template>
      <!-- image el END -->

      <!-- description START -->
      <template v-if="description">
        <template v-if="imageDescStyle === 'report-preparation'">
          <div
            :class="[
              'image-desc-wrapper',
              'image-desc-wrapper--report-preparation'
            ]">
            <div :class="['image-desc']">
              （图：{{ description }}）
            </div>
          </div>
        </template>
        <template v-else>
          <div class="image-desc-wrapper">
            <div class="image-desc">↑&nbsp;{{ description }}</div>
          </div>
        </template>
      </template>
      <!-- description END -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageItem',

  props: {
    item: {
      type: [String, Object],
      required: true,
    },

    lazy: {
      type: Boolean,
      default: false,
      require: false,
    },

    // imageLayout
    // 2022.07.13 image layout
    // values
    // - normal
    // - square
    imageLayout: {
      type: String,
      default: 'normal',
      required: false,
    },

    // imageDescStyle
    // 2022.07.13 image desc style
    // values
    // - normal ↑ <desc>
    // - report-preparation （图：<desc>）
    imageDescStyle: {
      type: String,
      default: 'normal',
      required: false,
    },
  },

  emits: [
    'image-item-did-press',
  ],

  data () {
    return {}
  },

  computed: {
    // source: 'src' attribute of <img>
    source () {
      if (this.item) {
        return this.item.src
          ? `${this.item.src}!/fw/960/rotate/auto/format/webp`
          : `${this.item}!/fw/960/rotate/auto/format/webp`
      }
      else {
        return null
      }
    },

    description () {
      return this.item && this.item.remark
        ? this.item.remark
        : null
    },
  },

  methods: {
    imageItemDidPress () {
      this.$emit('image-item-did-press', {
        item: this.item,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.image-item-wrapper {
  overflow: hidden;
  margin-bottom: 2px;

  &::before {
    display: none;
  }

  &:hover {
    cursor: pointer;
    filter: brightness(.95);
  }
}

.image-el-wrapper {
   &.image-el-wrapper--square {
    position: relative;
  }

  &.image-el-wrapper--square::before {
    content: '';
    padding-bottom: 100%;
    display: block;
  }
}

.image-el {
  display: block;
  margin: 0;
  width: 100%;

  &.image-el--square {
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: cover;
  }
}

.image-el:hover {
  cursor: pointer;
}

.image-desc-wrapper {
  margin-bottom: 8px;
  padding: 6px 16px 12px;
  display: block;
  box-sizing: border-box;

  &.image-desc-wrapper--report-preparation {
    padding: 2px 0px 0px;
  }
}

.image-desc {
  color: #414141;
  line-height: 1.475;
  white-space: pre-line;
  font-size: 1.025rem;
}

@media (min-width: 640px) {
  .image-desc {
    font-size: 1rem;
    line-height: 1.625;
  }
}

@media (prefers-color-scheme: dark) {
  .image-desc {
    color: #F0F0F0;
  }
}

</style>
